module.exports = __webpack_public_path__ + "static/media/phone-white.c0152af6.svg";